import { CrudApi } from './CrudApi';
import { BARatingFormula } from "@/models";
import { PaginatedResponse, QueryOptions, RepositoryQuery } from '@/../types/interfaces';
import { isEmpty, isNotEmpty } from '@/pipes';

class BARatingFormulaApi extends CrudApi<BARatingFormula> {
	constructor() {
		super('baRatingFormula', (obj) => new BARatingFormula().load(obj));
	}

	async exists(formula: BARatingFormula): Promise<BARatingFormula> {
		const query: RepositoryQuery<BARatingFormula> = { 
			$match: {...{ title: formula.title }, ...{ version: formula.version } }
		};
		const options: QueryOptions = {};
		const formulas: PaginatedResponse<BARatingFormula> = await this.queryAll(query, options);
		return ( formulas.count > 0 )? formulas.docs[0] : undefined;
	}

	async findActive(): Promise<BARatingFormula> {
		const formula: BARatingFormula = await CrudApi.Api(c => c.get(`/${this.resource}/active`));
		return new BARatingFormula().load(formula);
	}

	async setActive(formula: BARatingFormula): Promise<BARatingFormula> {
		if( isEmpty(formula) ) return undefined;

		// find the previously active formula
		const prevActive: BARatingFormula = await this.findActive();
		if( prevActive.title !== formula.title || prevActive.version !== formula.version ) {
			// un-activate the previous active formula
			prevActive.active = false;
			this.patch({id: prevActive.id, active: false});
		};

		// activate this formula
		formula.active = true;
		return this.patch({id: formula.id, active: true});
	}
}

export const baRatingFormulaApi = new BARatingFormulaApi();
